module.exports = {
    highlightedColour: "#b643e6", //"#10405D"
    timer2colour: "#9E1F44",
    timer3colour: "#FF668F",
    timer4colour: "#9E1F44",
    prizecardColour: "#0000FF"

}